export function toCurrency(val) {
  return val ? "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "";
}

export function daysFromDates(start, end) {
  if (!start || !end) {
    return null;
  }
  return Math.round((new Date(end).getTime() - new Date(start).getTime()) / (1000 * 3600 * 24));
}

export function capitalize(s) {
  return typeof s === 'string' ? s.charAt(0).toUpperCase() + s.slice(1) : '';
}

export function displayDate(date){
  if (!date){
    return null;
  }
  return new Date(date).toLocaleDateString();
}

export function limitToUnsignedByte(value) {
  if (value > 15) {
    return 15;
  } else if (value < 0) {
    return 0;
  }
  return value;
}

export function limitToInt(value) {
  if (value > 2147483647) {
    return 2147483647;
  } else if (value < -2147483648) {
    return -2147483648;
  }

  return value;
}